import Swiper from "swiper";

export function getKiaBaseUrl() {
  return window.location.href.includes("kia-web-htmleditor-components-prod")
    ? "https://www.kia.cn"
    : "https://uat.kia.cn";
}

export function getMobileLoopAutoplayOptions(overrides = {}) {
  return {
    slidesPerView: 1,
    spaceBetween: 0,
    // loop: true,
    // autoplay: {
    //   delay: 5000,
    //   disableOnInteraction: false,
    // },
    ...overrides,
  };
}

export function createSwiperInstance(containerEl, options = {}) {
  if (!containerEl) return null;
  return new Swiper(containerEl, options);
}

export function destroySwiperInstance(instance) {
  if (instance && typeof instance.destroy === "function") {
    instance.destroy(true, true);
  }
}

export const SWIPER_GROUP_2_VIDEO_URLS = [
  "https://img.kia.cn/media/videos/202606/fifa/20260603.mp4",
  "https://img.kia.cn/media/videos/202606/fifa/260519.mp4",
  "https://img.kia.cn/media/videos/202606/fifa/260119.mp4",
  "https://img.kia.cn/media/videos/202606/fifa/260228.mp4",
  "https://img.kia.cn/media/videos/202606/fifa/260522.mp4",
];

export function applySharedSlideVideos(slides, videoUrls = []) {
  return slides.map((slide, index) => {
    const videoUrl = videoUrls[index] || "";
    return {
      ...slide,
      videoPc: videoUrl,
      videoMob: videoUrl,
    };
  });
}

export function buildSwiperGroupImages(group, count = 3) {
  const groupNumber = Number(group);
  const total = Number(count) > 0 ? Number(count) : 3;
  const slides = Array.from({ length: total }, (_, i) => i + 1);
  return slides.map((slide, index) => ({
    index,
    urlPc: `/assets/~/media/images/activity/202606worldcup/pc/swiper/${groupNumber}-${slide}.png`,
    urlMob: `/assets/~/media/images/activity/202606worldcup/mob/swiper/${groupNumber}-${slide}.png`,
    videoPc: '',
    videoMob: 'https://img.kia.cn/media/videos/202601/618meijie20260603.mp4',
  }));
}
